const setOffice = ({ commit }, payload) => {
  commit('SET_OFFICE', payload)
}

const setOfficeLoading = ({ commit }, payload) => {
  commit('SET_OFFICE_LOADING', payload)
}

const setProfessionals = ({ commit }, payload) => {
  commit('SET_PROFESSIONALS', payload)
}

const setProfessionalsLoading = ({ commit }, payload) => {
  commit('SET_PROFESSIONALS_LOADING', payload)
}

const setClients = ({ commit }, payload) => {
  commit('SET_CLIENTS', payload)
}

const setClientsLoading = ({ commit }, payload) => {
  commit('SET_CLIENTS_LOADING', payload)
}

const setClientsGrouped = ({ commit }, payload) => {
  commit('SET_CLIENTS_GROUPED', payload)
}

const setClientsGroupedLoading = ({ commit }, payload) => {
  commit('SET_CLIENTS_GROUPED_LOADING', payload)
}

export {
  setOffice,
  setProfessionals,
  setClients,
  setOfficeLoading,
  setProfessionalsLoading,
  setClientsLoading,
  setClientsGrouped,
  setClientsGroupedLoading,
}
